import { docsConcepts as rawDocsConcepts } from './data.js';
import type { SemanticPage } from './types.js';

export const docsConcepts = rawDocsConcepts as SemanticPage[];
